module.exports = __webpack_public_path__ + "static/media/2.81b00f3e.svg";